var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-tag",class:{ active: (_vm.id && _vm.active) || (!_vm.id && !_vm.active) },attrs:{"data-id":"id-0"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }